module.exports = __webpack_public_path__ + "img/instagram.e7f98c21.svg";